import { Spinner } from "../../shared/ui";

const ACCENT = "#FF6B35";

export default function EmojiMovieHost({ q, answered, result, timeLeft, players, tv }) {
  const fs = (a, b) => tv ? a : b;

  if (!q) return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
      <Spinner color={ACCENT} tv={tv} />
    </div>
  );

  const options = q.options || [];
  const correct = result?.correct;
  const timerColor = timeLeft > 5 ? ACCENT : "#ff3355";

  return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center",
      gap: fs("1.5rem", "1rem"), padding: fs("2rem", "1rem"),
      maxWidth: "700px", margin: "0 auto", width: "100%",
    }}>

      {/* Таймер */}
      <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
        <div style={{
          width: fs("3.5rem", "2.5rem"), height: fs("3.5rem", "2.5rem"),
          borderRadius: "9999px", background: timerColor,
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: fs("1.5rem", "1.1rem"), fontWeight: "bold", color: "#fff",
          transition: "background 0.3s", boxShadow: `0 0 16px ${timerColor}`,
        }}>
          {timeLeft}
        </div>
        <span style={{ color: "#aaa", fontSize: fs("1rem", "0.75rem"), fontFamily: "var(--font-body)" }}>
          сек
        </span>
      </div>

      {/* Эмодзи — только во время вопроса */}
      {!result && (
        <div style={{
          fontSize: fs("4rem", "2.8rem"), textAlign: "center",
          background: "#111", border: `2px solid ${ACCENT}`, borderRadius: "1.5rem",
          padding: fs("1.5rem 2.5rem", "1rem 1.5rem"), letterSpacing: "0.3rem",
          boxShadow: `0 0 30px ${ACCENT}44`,
        }}>
          {q.emoji}
        </div>
      )}

      {/* Варианты / результат */}
      {!result ? (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: fs("1rem", "0.6rem"), width: "100%" }}>
          {options.map((opt, i) => (
            <div key={i} style={{
              background: "#1a1a1a", border: `2px solid ${ACCENT}55`,
              borderRadius: "1rem", padding: fs("1rem", "0.7rem"),
              textAlign: "center", fontSize: fs("1.1rem", "0.85rem"),
              color: "#fff", fontFamily: "var(--font-heading)",
            }}>
              {opt}
            </div>
          ))}
        </div>
      ) : (
        <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: fs("0.8rem", "0.5rem"), alignItems: "center" }}>
          <div style={{ fontSize: fs("3rem", "2rem"), marginBottom: "0.3rem" }}>{q.emoji}</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: fs("0.8rem", "0.5rem"), width: "100%" }}>
            {options.map((opt, i) => {
              const isCorrect = i === correct;
              return (
                <div key={i} style={{
                  background: isCorrect ? "#00cc6644" : "#1a1a1a",
                  border: `2px solid ${isCorrect ? "#00cc66" : "#333"}`,
                  borderRadius: "1rem", padding: fs("0.9rem", "0.6rem"),
                  textAlign: "center", fontSize: fs("1rem", "0.8rem"),
                  color: isCorrect ? "#00cc66" : "#888",
                  fontFamily: "var(--font-heading)", fontWeight: isCorrect ? "bold" : "normal",
                }}>
                  {isCorrect ? "✅ " : ""}{opt}
                </div>
              );
            })}
          </div>

          {/* Кто как ответил */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: "0.4rem", justifyContent: "center", marginTop: "0.3rem" }}>
            {players.map(p => {
              const ans = result.answers?.[p.name];
              const isRight = ans === correct;
              return (
                <div key={p.name} style={{
                  background: ans === undefined ? "#222" : isRight ? "#00cc6633" : "#ff335533",
                  border: `1.5px solid ${ans === undefined ? "#444" : isRight ? "#00cc66" : "#ff3355"}`,
                  borderRadius: "2rem", padding: "0.2rem 0.7rem",
                  fontSize: fs("0.9rem", "0.7rem"),
                  color: ans === undefined ? "#888" : isRight ? "#00cc66" : "#ff3355",
                  fontFamily: "var(--font-body)",
                }}>
                  {ans === undefined ? "⏳" : isRight ? "✅" : "❌"} {p.name}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Кто уже ответил (во время вопроса) */}
      {!result && answered.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "0.4rem", justifyContent: "center" }}>
          {answered.map(n => (
            <div key={n} style={{
              background: `${ACCENT}33`, border: `1.5px solid ${ACCENT}`,
              borderRadius: "2rem", padding: "0.2rem 0.6rem",
              fontSize: fs("0.85rem", "0.65rem"), color: ACCENT,
              fontFamily: "var(--font-body)",
            }}>
              ✓ {n}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
